import * as Actions from './advanced-filter.actions';
import { IAdvancedFilterStore } from './advanced-filter.model';
import { Action } from '@ngrx/store';
import _ from 'lodash';

export const advancedFilterInitialState: IAdvancedFilterStore = {
  isSaveFilterConfigLoading: false,
  isSaveFilterConfigLoaded: false,
  savedFilters: {},
  defaultFilters: {},
  isGetCustomFilterConfigLoading: false,
  isGetCustomFilterConfigLoaded: false,
  customDefaultFilters: null,
  isAddCustomFilterConfigLoading: false,
  isAddCustomFilterConfigLoaded: false,
  isUpdateCustomFilterConfigLoading: false,
  isUpdateCustomFilterConfigLoaded: false,
  savedCustomDefaultFilters: null,
};

export const advancedFilterReducer = (state: IAdvancedFilterStore = advancedFilterInitialState, baseAction: Action) => {
  const action = baseAction as Actions.AdvancedFilterActions;

  switch (action.type) {
    case Actions.SAVE_FILTER_CONFIG:
      return {
        ...state,
        isDefaultFiltersLoading: true,
        isDefaultFiltersLoaded: false,
      };

    case Actions.SAVE_FILTER_CONFIG_COMPLETED:
      return {
        ...state,
        isDefaultFiltersLoading: false,
        isDefaultFiltersLoaded: true,
        savedFilters: _.cloneDeep(action.payload),
      };

    case Actions.SET_DEFAULT_FILTERS:
      return {
        ...state,
        defaultFilters: _.cloneDeep(action.payload),
      };

    case Actions.GET_CUSTOM_FILTER_CONFIG:
      return {
        ...state,
        isGetCustomFilterConfigLoading: true,
        isGetCustomFilterConfigLoaded: false,
        savedCustomDefaultFilters: null,
        customDefaultFilters: null,
      };

    case Actions.GET_CUSTOM_FILTER_CONFIG_COMPLETED:
      return {
        ...state,
        isGetCustomFilterConfigLoading: false,
        isGetCustomFilterConfigLoaded: true,
        customDefaultFilters: _.cloneDeep(action.payload),
      };

    case Actions.ADD_CUSTOM_FILTER_CONFIG:
      return {
        ...state,
        isAddCustomFilterConfigLoading: true,
        isAddCustomFilterConfigLoaded: false,
      };

    case Actions.ADD_CUSTOM_FILTER_CONFIG_COMPLETED:
      return {
        ...state,
        isAddCustomFilterConfigLoading: false,
        isAddCustomFilterConfigLoaded: true,
        savedCustomDefaultFilters: _.cloneDeep(action.payload),
      };

    case Actions.UPDATE_CUSTOM_FILTER_CONFIG:
      return {
        ...state,
        isUpdateCustomFilterConfigLoading: true,
        isUpdateCustomFilterConfigLoaded: false,
      };

    case Actions.UPDATE_CUSTOM_FILTER_CONFIG_COMPLETED:
      return {
        ...state,
        isUpdateCustomFilterConfigLoading: false,
        isUpdateCustomFilterConfigLoaded: true,
        savedCustomDefaultFilters: _.cloneDeep(action.payload),
      };

    case Actions.CLEAR_CUSTOM_FILTER_CONFIG:
      return {
        ...state,
        isGetCustomFilterConfigLoading: false,
        isGetCustomFilterConfigLoaded: false,
        isAddCustomFilterConfigLoading: false,
        isAddCustomFilterConfigLoaded: false,
        isUpdateCustomFilterConfigLoading: false,
        isUpdateCustomFilterConfigLoaded: false,
        savedCustomDefaultFilters: null,
        customDefaultFilters: null,
      };

    default:
      return state;
  }
};
